import React from 'react';

import { FormTextarea, FormTextareaProps } from '@splitfiesta/ui';

import { useTextareaAutoExpand } from '@/hooks/useTextareaAutoExpand';

export interface FormTextareaAutoExpandProps extends FormTextareaProps {
  minHeight?: number;
  maxHeight?: number;
  ref?: React.Ref<HTMLTextAreaElement>;
}

export function FormTextareaAutoExpand({
  minHeight = 60,
  maxHeight = 200,
  ref: forwardedRef,
  ...props
}: FormTextareaAutoExpandProps) {
  const autoExpandRef = useTextareaAutoExpand(props.value, {
    minHeight,
    maxHeight,
  });

  return (
    <FormTextarea
      {...props}
      ref={element => {
        // Handle both refs
        if (typeof forwardedRef === 'function') {
          forwardedRef(element);
        } else if (forwardedRef) {
          forwardedRef.current = element;
        }

        // Set our auto-expand ref
        if (
          autoExpandRef &&
          'current' in autoExpandRef &&
          autoExpandRef.current !== undefined
        ) {
          (
            autoExpandRef as React.MutableRefObject<HTMLTextAreaElement | null>
          ).current = element;
        }
      }}
      resize="none" // Disable manual resize when auto-expanding
    />
  );
}
